import { render } from "./BankCollected.vue?vue&type=template&id=416e308d"
import script from "./BankCollected.vue?vue&type=script&lang=js"
export * from "./BankCollected.vue?vue&type=script&lang=js"

import "./BankCollected.vue?vue&type=style&index=0&id=416e308d&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__